import { render, staticRenderFns } from "./CrewLaborDetail.vue?vue&type=template&id=279fbf2b"
import script from "./CrewLaborDetail.vue?vue&type=script&lang=js"
export * from "./CrewLaborDetail.vue?vue&type=script&lang=js"
import style0 from "./CrewLaborDetail.vue?vue&type=style&index=0&id=279fbf2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports